/* eslint-disable no-unused-vars */
import fileDownload from 'js-file-download';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { apiClient, handleResponse } from './axios';
import { authHeader } from '../../helpers/authHeader';
import config from '../../config';

const getExams = () => apiClient.get('/examsubject')
  .then(handleResponse);

async function getExamsByCompany(idcompany) {
  try {
    const response = await apiClient.get(`/exam/company/${idcompany}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function postExam(companyId, semester, exam) {
  try {
    const response = await apiClient.put(`/exam/new/${companyId}/${semester}`, exam);
    const elearning = await handleResponse(response);
    return elearning;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getExamsByGroup(idgroup) {
  try {
    const response = await apiClient.get(`/exam/group/${idgroup}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function convertexam(content) {
  try {
    const res = await axios.post(`${config.API_URL}/convert/pdf`, content, {
      headers: {
        Authorization: authHeader(),
      },
      responseType: 'blob',
    });
    return res.data;
  } catch (error) {
    const res = await Promise.resolve(error.response.data.message.toString());
    return res;
  }
}

async function getExamResults(userId, groupId, token, activityId) {
  const headers = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  try {
    const response = await axios.get(`${config.API_URL}/exam/quizmaker/${userId}/${groupId}/${activityId}`, headers);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function getExamPDFResults(userId, examId) {
  try {
    const response = await apiClient
      .get(`/examresult/${userId}/${examId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateExam(elearningoptionsid, exam) {
  try {
    const response = await apiClient.put(`/exam/update/${elearningoptionsid}`, exam);
    const elearning = await handleResponse(response);
    return elearning;
  } catch (error) {
    return error;
  }
}

const followupServices = {
  getExams,
  getExamsByCompany,
  getExamsByGroup,
  convertexam,
  getExamResults,
  getExamPDFResults,
  postExam,
  updateExam,
};

export default followupServices;
